<template>
  <div>
    <user-add user-title="用户管理" user-add-url="/user/manage/add" />
    <el-table :data="Cdata">
      <el-table-column label="ID" width="100" prop="id"></el-table-column>
      <el-table-column label="*用户名" prop="userName" ></el-table-column>
      <el-table-column label="*密码" prop="password" ></el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" ></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import UserAdd from "@/views/User/Common/UserAdd";
export default {
  name: "ManageBase",
  components: {UserAdd},
  data(){
    return{
      Cdata:null,//当前表格展示数据
    }
  },
  created() {
    this.GetData(this.PostData)
  },
  methods:{
    GetData(PageData){
      this.$axios.get('/api/user/getAll',PageData).then(res=>{
        this.Cdata=res.data.data
      })
    },
    handleLook(id){
      this.$router.push('/user/manage/look'+id)
    },
    handleChange(id){
      this.$router.push('/user/manage/change'+id)
    },
    Delete(id){
      this.$axios.delete('/api/user/deleteById',{params:{
          id:id
        }}).then(res=>{
        this.GetData(this.PostData)
      })
    },
    handleDelete(id){
      this.$confirm('确定删除该条信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Delete(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  }
}
</script>

<style scoped>

</style>